import script from "./TopBarMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopBarMenu.vue?vue&type=script&lang=ts&setup=true"

import "./TopBarMenu.vue?vue&type=style&index=0&id=bc2e83f6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc2e83f6"]])

export default __exports__